 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		92: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		92: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"18":"App2DPaymentComplete","19":"AppPayment","20":"AppPaymentComplete","21":"AppPaymentProcessing","22":"AxsTravelInsure","23":"BusinessProtect360.Generate","24":"CILeadForm","25":"CIP.FactFormApp","26":"CIProtect360.Dashboard","27":"CIProtect360.Details","28":"CIProtect360.Direct.Generate","29":"CIProtect360.Generate","30":"CampaignLeadForm","31":"CarProtect360","32":"CashCardShield","33":"ChoicesProtect360","34":"CommissionStatement","35":"Common.Error","36":"Common.MyInfoCallback","37":"ComplimentaryHomeContents","38":"ConsumerPortal","39":"ContactUs","40":"CorporateTravel","41":"CrossBorderProtectWithUpgrade","42":"Debug","43":"EMAPortal","44":"EarlyProtect360Plus","45":"EarlyProtect360Plus.Dashboard","46":"EarlyProtect360Plus.Details","47":"FamilyProtect360","48":"FamilyProtectLiteWithUpgrade","49":"FilipinoBond","50":"FlashPayShieldWithUpgrade","51":"FraudProtect360","52":"HIProtect360Protect360","53":"HomeProtect360","54":"HomeProtectLite","55":"HomeSafe","56":"HomeStarterKit","57":"InternalDemoCookie","58":"KeymanProtect360","59":"KeymanProtect360.Dashboard","60":"KeymanProtect360.Details","61":"LeadForm","62":"Loan Protect 360 Renewal","63":"LoanProtect360","64":"LoanProtect360.Dashboard","65":"LoanProtect360.Details","66":"MaidProtect360","67":"MotoringCardShieldWithUpgrade","68":"Motorshow2020","69":"PartnerProgram","70":"PhoneProtect360","71":"PowerAgentPortal","72":"Prestige","73":"Prestige.Secured","74":"PublicHousingAssured","75":"ReviewUs","76":"SBSTPAProtectLite","77":"SBSTPAProtectPlus","78":"SBSTTravelInsurance","79":"SOA","80":"SimplyGo","81":"SingaporeTravelPass","82":"Touristcard","83":"TravelAssured","84":"TravelAssuredPlus","85":"TravelProtect360","86":"TravelProtect360Plus","87":"cileadform","88":"currencyconverter","89":"freehomeinsurance","91":"motorshow","93":"transferprotect360pro","94":"vCashCard","95":"weather"}[chunkId]||chunkId) + "." + {"0":"ddc8cdad","1":"e94c8ca9","2":"a41c39c1","3":"33362636","4":"1a2f8f9d","5":"1ac8ace5","6":"bc2457b7","7":"41bbe130","8":"8e3086b8","9":"7e459b07","10":"52b2058a","11":"519a8da6","12":"e237aa75","13":"6d2cfd92","14":"0d042919","15":"dd899c49","16":"8893d744","17":"3ea530ac","18":"4f893a94","19":"a03f9fe8","20":"c54b7f53","21":"18435c01","22":"2e38d1ab","23":"35b8ecb1","24":"14e9644e","25":"807cb9b6","26":"75d97c63","27":"39945b7c","28":"f15694fc","29":"71459b79","30":"a8d63fc7","31":"6666054a","32":"e42a7f13","33":"50fb2b8f","34":"4f5081af","35":"a24004c1","36":"485d9d73","37":"ac8ba285","38":"3da536ce","39":"2ca9f565","40":"65804762","41":"b31db1b3","42":"9e4d4e32","43":"25bfb0f8","44":"feba0b26","45":"55868ad1","46":"22c5d305","47":"94345c66","48":"70bf421b","49":"c19f096d","50":"642decd5","51":"5f9933bc","52":"a728fc0a","53":"d1c936a9","54":"39950c83","55":"93578fdb","56":"709c232f","57":"8fd43c79","58":"27818308","59":"f5f393a6","60":"7f598842","61":"a7e7d740","62":"60b99c9b","63":"f9352b1d","64":"90df6a0c","65":"0880788d","66":"858b31f0","67":"1af9ce16","68":"5f89c9d5","69":"d07b030d","70":"2aadad2c","71":"553a3a38","72":"449c72ce","73":"a064ebde","74":"ad13120a","75":"24cd0167","76":"196d0a81","77":"3ef1c1d4","78":"8b09bb39","79":"44fe15e9","80":"959c40eb","81":"d11fca94","82":"b4db7d56","83":"f9a82bcc","84":"75ae6da2","85":"95f784cc","86":"932c687c","87":"ddf8d5f4","88":"61950cdb","89":"51c41cc1","91":"b23ba411","93":"fb239a52","94":"851b6047","95":"832fa13b","97":"65cba348","98":"37e0460e","99":"571c9408","100":"aa5727bc","101":"70ab0276","102":"507ccd7b","103":"1382c381","104":"f9c5674a","105":"5254e01c","106":"06f06364","107":"dcb9e452","108":"99497e75","109":"0009964a","110":"d4ccd08d","111":"4813f718","112":"ac4a8b94","113":"a231f37d","114":"927e18c7","115":"47bf0e96","116":"07d3eac2","117":"d220932c","118":"d04f088c","119":"0ed27649","120":"e15bd090","121":"3e003324","122":"2e7779df","123":"7b776b06","124":"e3e24cd8","125":"d7cb9054","126":"4ab2dff7","127":"cf50ab7e","128":"80ad8196","129":"50f2cecf","130":"8e965ea9","131":"ff03cf1b","132":"8c2386f3","133":"17add621","134":"68434e83","135":"80ddc7b8","136":"6b05c796","137":"5684364d","138":"0fa360c2","139":"7f8cd73e","140":"ee5b1683","141":"69122fd6","142":"8714893f","143":"f3773dc2","144":"21960b37","145":"3d9622e9","146":"95bcfb45","147":"b47ea1ba","148":"af8f1100","149":"0c9556ed","150":"634a41ee","151":"6dda9cf8","152":"b4e7287f","153":"a8af5e4d","154":"e5069e71","155":"09090638","156":"939bec37","157":"decae363","158":"5f27c16b","159":"b2cfc4ec","160":"431f0e79","161":"849a6324","162":"c7cb2c7c","163":"3d9bfcc3","164":"3356c182","165":"d06f5b50","166":"4e1d4d4b","167":"84692cf0","168":"7478ce88","169":"4dc11291","170":"216da8b4","171":"c1f8d1dc","172":"841f1816","173":"dd940394","174":"477ffaaa","175":"7deee08d","176":"2342cf70","177":"7f1841bb","178":"f3f25b94"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"19":1,"21":1,"22":1,"23":1,"25":1,"28":1,"30":1,"31":1,"32":1,"33":1,"34":1,"37":1,"38":1,"40":1,"41":1,"42":1,"44":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"58":1,"61":1,"66":1,"67":1,"69":1,"70":1,"71":1,"72":1,"73":1,"74":1,"76":1,"77":1,"78":1,"79":1,"80":1,"81":1,"82":1,"83":1,"84":1,"85":1,"86":1,"87":1,"88":1,"89":1,"91":1,"93":1,"94":1,"95":1,"98":1,"99":1,"101":1,"102":1,"103":1,"104":1,"105":1,"106":1,"107":1,"108":1,"109":1,"110":1,"113":1,"117":1,"121":1,"122":1,"126":1,"127":1,"131":1,"132":1,"133":1,"134":1,"135":1,"136":1,"137":1,"138":1,"139":1,"140":1,"141":1,"142":1,"143":1,"144":1,"156":1,"157":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"18":"App2DPaymentComplete","19":"AppPayment","20":"AppPaymentComplete","21":"AppPaymentProcessing","22":"AxsTravelInsure","23":"BusinessProtect360.Generate","24":"CILeadForm","25":"CIP.FactFormApp","26":"CIProtect360.Dashboard","27":"CIProtect360.Details","28":"CIProtect360.Direct.Generate","29":"CIProtect360.Generate","30":"CampaignLeadForm","31":"CarProtect360","32":"CashCardShield","33":"ChoicesProtect360","34":"CommissionStatement","35":"Common.Error","36":"Common.MyInfoCallback","37":"ComplimentaryHomeContents","38":"ConsumerPortal","39":"ContactUs","40":"CorporateTravel","41":"CrossBorderProtectWithUpgrade","42":"Debug","43":"EMAPortal","44":"EarlyProtect360Plus","45":"EarlyProtect360Plus.Dashboard","46":"EarlyProtect360Plus.Details","47":"FamilyProtect360","48":"FamilyProtectLiteWithUpgrade","49":"FilipinoBond","50":"FlashPayShieldWithUpgrade","51":"FraudProtect360","52":"HIProtect360Protect360","53":"HomeProtect360","54":"HomeProtectLite","55":"HomeSafe","56":"HomeStarterKit","57":"InternalDemoCookie","58":"KeymanProtect360","59":"KeymanProtect360.Dashboard","60":"KeymanProtect360.Details","61":"LeadForm","62":"Loan Protect 360 Renewal","63":"LoanProtect360","64":"LoanProtect360.Dashboard","65":"LoanProtect360.Details","66":"MaidProtect360","67":"MotoringCardShieldWithUpgrade","68":"Motorshow2020","69":"PartnerProgram","70":"PhoneProtect360","71":"PowerAgentPortal","72":"Prestige","73":"Prestige.Secured","74":"PublicHousingAssured","75":"ReviewUs","76":"SBSTPAProtectLite","77":"SBSTPAProtectPlus","78":"SBSTTravelInsurance","79":"SOA","80":"SimplyGo","81":"SingaporeTravelPass","82":"Touristcard","83":"TravelAssured","84":"TravelAssuredPlus","85":"TravelProtect360","86":"TravelProtect360Plus","87":"cileadform","88":"currencyconverter","89":"freehomeinsurance","91":"motorshow","93":"transferprotect360pro","94":"vCashCard","95":"weather"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"a858c2f5","20":"31d6cfe0","21":"a858c2f5","22":"86c9f98d","23":"d30bc41f","24":"31d6cfe0","25":"d33f62d9","26":"31d6cfe0","27":"31d6cfe0","28":"58058363","29":"31d6cfe0","30":"05f863ac","31":"ddf1f108","32":"04bc7233","33":"ddf1f108","34":"d33f62d9","35":"31d6cfe0","36":"31d6cfe0","37":"0e4fba13","38":"978e5247","39":"31d6cfe0","40":"ac3f861f","41":"0e4fba13","42":"5d27deaa","43":"31d6cfe0","44":"58058363","45":"31d6cfe0","46":"31d6cfe0","47":"ddf1f108","48":"0e4fba13","49":"ddf1f108","50":"0e4fba13","51":"ddf1f108","52":"ddf1f108","53":"471a3a57","54":"471a3a57","55":"471a3a57","56":"0e4fba13","57":"31d6cfe0","58":"58058363","59":"31d6cfe0","60":"31d6cfe0","61":"dd9a60e3","62":"31d6cfe0","63":"31d6cfe0","64":"31d6cfe0","65":"31d6cfe0","66":"14284125","67":"0e4fba13","68":"31d6cfe0","69":"8b647349","70":"471a3a57","71":"716aad65","72":"2fc531d7","73":"cdec5a50","74":"471a3a57","75":"31d6cfe0","76":"39dd3a27","77":"e81d10c5","78":"86c9f98d","79":"d33f62d9","80":"98c15efc","81":"2e8fdc12","82":"7986da5d","83":"86c9f98d","84":"86c9f98d","85":"2e8fdc12","86":"86c9f98d","87":"22b92479","88":"7b4f34de","89":"0e4fba13","91":"49234f01","93":"14284125","94":"94b03ce8","95":"23255cb6","97":"31d6cfe0","98":"cce35a68","99":"440606be","100":"31d6cfe0","101":"2d576837","102":"166c8acc","103":"db5d06da","104":"f93319e8","105":"f93319e8","106":"72c6f688","107":"72c6f688","108":"72c6f688","109":"f93319e8","110":"72c6f688","111":"31d6cfe0","112":"31d6cfe0","113":"6f6df1fe","114":"31d6cfe0","115":"31d6cfe0","116":"31d6cfe0","117":"6f6df1fe","118":"31d6cfe0","119":"31d6cfe0","120":"31d6cfe0","121":"6f6df1fe","122":"6f6df1fe","123":"31d6cfe0","124":"31d6cfe0","125":"31d6cfe0","126":"4b48318c","127":"4b48318c","128":"31d6cfe0","129":"31d6cfe0","130":"31d6cfe0","131":"4b48318c","132":"4b48318c","133":"4b48318c","134":"4b48318c","135":"4b48318c","136":"4b48318c","137":"4b48318c","138":"4b48318c","139":"4b48318c","140":"4b48318c","141":"4b48318c","142":"4b48318c","143":"4b48318c","144":"4b48318c","145":"31d6cfe0","146":"31d6cfe0","147":"31d6cfe0","148":"31d6cfe0","149":"31d6cfe0","150":"31d6cfe0","151":"31d6cfe0","152":"31d6cfe0","153":"31d6cfe0","154":"31d6cfe0","155":"31d6cfe0","156":"5fe6802c","157":"5fe6802c","158":"31d6cfe0","159":"31d6cfe0","160":"31d6cfe0","161":"31d6cfe0","162":"31d6cfe0","163":"31d6cfe0","164":"31d6cfe0","165":"31d6cfe0","166":"31d6cfe0","167":"31d6cfe0","168":"31d6cfe0","169":"31d6cfe0","170":"31d6cfe0","171":"31d6cfe0","172":"31d6cfe0","173":"31d6cfe0","174":"31d6cfe0","175":"31d6cfe0","176":"31d6cfe0","177":"31d6cfe0","178":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.hlas.com.sg/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonphlas-react-app"] = this["webpackJsonphlas-react-app"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
